// Botón global "Volver" — visible en todas las páginas excepto rutas raíz.
// Usa history.back() si hay historial previo, o navega a la ruta padre derivada del pathname.
import { useLocation, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

// Rutas donde NO se muestra el botón (páginas de entrada / landings por módulo)
const ROOT_ROUTES = new Set([
  '/',
  '/login',
  '/dashboard',
  '/manual',
  '/aprobaciones',
]);

export function BackButton() {
  const location = useLocation();
  const navigate = useNavigate();

  const pathname = location.pathname;
  if (ROOT_ROUTES.has(pathname)) return null;

  // Profundidad 1 (ej: /compras, /bodega, /rrhh) también se considera raíz de módulo
  const segments = pathname.split('/').filter(Boolean);
  if (segments.length <= 1) return null;

  const handleBack = () => {
    // Si hay historial real dentro de la app (state.idx > 0) usar history.back()
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      // Fallback: navegar a la ruta padre (ej: /bodega/recepcion-oc → /bodega)
      const parent = '/' + segments.slice(0, -1).join('/');
      navigate(parent || '/dashboard');
    }
  };

  return (
    <button
      onClick={handleBack}
      className="mx-4 mt-4 lg:mx-6 lg:mt-6 inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors group"
      data-testid="btn-back-global"
      aria-label="Volver a la página anterior"
    >
      <ArrowLeft className="w-3.5 h-3.5 transition-transform group-hover:-translate-x-0.5" />
      Volver
    </button>
  );
}

export default BackButton;
